import _get from 'lodash/get';
import {
    FOR_RENT_ID,
    FOR_SALE_AND_PREMARKET_SUBCATEGORY_IDS,
    RECENTLY_SOLD_ID,
} from '../constants';

export const getIsMobileLayout = state => _get(state, 'searchPageConstants.isMobile', true);

export const getIsTablet = state => _get(state, 'searchPageConstants.isTablet');

export const getHasAdGptScriptLoaded = state => _get(state, 'uiState.adGptScriptLoaded', false);

export const getHasAdPrebidScriptLoaded = state =>
    _get(state, 'uiState.adPrebidScriptLoaded', false);

export const getHasAdPrebidScriptFailed = state =>
    _get(state, 'uiState.adPrebidScriptFailed', false);

export const getNumListColumns = state => _get(state, 'uiState.numListColumns', 0);

export const getIsAdStateTrialOn = state =>
    _get(state, 'abTrials.SRP_MEDIASOLUTIONS_STATEMACHINE', 'CONTROL') === 'ON';

export const getAdLoadSpeedTrial = state => _get(state, 'abTrials.MST_SRP_WEB_SPEED', 'CONTROL');

export const getIsSecondNavAdSlot13Enabled = state =>
    _get(state, 'abTrials.MST_SRP_WEB_2NDAD13AND17', 'CONTROL') === 'SLOT13';

export const getIsSecondNavAdSlot17Enabled = state =>
    _get(state, 'abTrials.MST_SRP_WEB_2NDAD13AND17', 'CONTROL') === 'SLOT17';

export const getForSaleSubCategoryIds = () => [...FOR_SALE_AND_PREMARKET_SUBCATEGORY_IDS];

export const getFilterBooleanValue = (state, filterId) => {
    const filterState =
        state?.queryState?.filterState?.[filterId] || state?.defaultFilterState?.[filterId];
    return filterState ? !!filterState.value : false;
};

export const categoryCheckboxValue = (state, subcategoryIds) => {
    const checkedSubFilters = subcategoryIds.filter(id => getFilterBooleanValue(state, id));
    return checkedSubFilters.length >= 1;
};

export const isForSaleChecked = state => categoryCheckboxValue(state, getForSaleSubCategoryIds());

export const isRentalOnlyChecked = state =>
    getFilterBooleanValue(state, FOR_RENT_ID) &&
    !isForSaleChecked(state) &&
    !getFilterBooleanValue(state, RECENTLY_SOLD_ID);
